import { Component, OnInit, ViewChild, EventEmitter, Output, TemplateRef, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';


@Component({
  selector: 'bz-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss']
})
export class InfoDialogComponent implements OnInit {
  constructor(private modalService: BsModalService) { }

  public modalRef: BsModalRef;
  @ViewChild('infoDialog', { static: false}) infoDialog: TemplateRef<any>;
  @Output() onClose: EventEmitter<void> = new EventEmitter<void>();

  ngOnInit() { }

  showDialog(){
    this.modalRef = this.modalService.show(this.infoDialog);
  }
  hideDialog(){
    this.modalRef.hide();
  }
  closeDialog(){
    this.onClose.emit();
    this.modalRef.hide();
  }

}
